const config = {
    path: 'https://staging-na-us.maybelline.com',
    // path: 'https://www.maybelline.com',
    debugMode: false,
    debugPath: false,
    guest: false,
    token: '',
    playerId: '',
    tutorials: {
        background_release: false,
        fill_bar: false,
        drop_product: false
    },
    score: 0,
    level: 0,
    nickname: '',
    gameId: null
}

export default config;